import React from 'react';
import { Stack, useTheme, Text, IStyleFunctionOrObject, IStyle, mergeStyles, mergeStyleSets, memoizeFunction, ITheme, IIconStyles, IRawStyle } from '@fluentui/react';
import { notificationIconContainerStyles, notificationIconSmallContainerStyles, notificationIconXSmallContainerStyles, notificationTextSmallStyles, notificationTextStyles, notificationTextXSmallStyles } from '../styles';

export type NotificationIconSize = 'xsmall' | 'small' | 'middle';
export type HorizontalAlign = 'left' | 'right';

export type NotificationIconProps = {
    chatMessagesCount: number;
    size?: NotificationIconSize;
    horizontalAlign?: HorizontalAlign;
    label?: string;
    /**
     * Gets the styles for an Icon.
     */
    styles?: IIconStyles;
};

function getNotificationTextStyles(theme: ITheme, size: NotificationIconSize) {
    switch (size) {
        case 'xsmall': return notificationTextXSmallStyles(theme);
        case 'small': return notificationTextSmallStyles(theme);
        default: return notificationTextStyles(theme);
    }
}

function getNotificationIconContainerStyles(theme: ITheme, size: NotificationIconSize, horizontalAlign: HorizontalAlign) {
    switch (size) {
        case 'xsmall': return notificationIconXSmallContainerStyles(theme, horizontalAlign);
        case 'small': return notificationIconSmallContainerStyles(theme, horizontalAlign);
        default: return notificationIconContainerStyles(theme, horizontalAlign);
    }
}

/**
 * @private
 */
export const NotificationIcon = (props: NotificationIconProps): JSX.Element => {
    const { chatMessagesCount, label, size = 'middle', horizontalAlign = 'right' } = props;
    const theme = useTheme();
    const renderNumber = (numberOfMessages: number): JSX.Element => {
        if (numberOfMessages < 1) {
            return <></>;
        } else {
            const textNumberOfMessages = numberOfMessages < 9 ? numberOfMessages : '9+';
            return (
                <Text role={'status'} aria-label={textNumberOfMessages + (label ?? '')} styles={getNotificationTextStyles(theme, size)}>
                    {textNumberOfMessages}
                </Text>
            );
        }
    };

    return (
        <Stack
            data-ui-id="call-with-chat-composite-chat-button-unread-icon"
            horizontalAlign="center"
            verticalAlign="center"
            className={mergeStyles(
                getNotificationIconContainerStyles(theme, size, horizontalAlign).root,
                props.styles?.root
            )}
        >
            <Stack>{renderNumber(chatMessagesCount)}</Stack>
        </Stack>
    );
};
